import { React, Component, Container, _ } from 'utils';
import CampaignList from './campaignList';
import { Creators, Campaigns } from 'model';

class LatestContainer extends Component {

	static getStores() {
		return [Campaigns];
	}

	static calculateState() {
		var { active, campaigns } = Campaigns.getState();
		return { active, campaigns };
	}

	render() {

		var { active, campaigns } = this.state;

		if(active) {

			return <div className="campaign">
				<h4>{ _('Mape')}</h4>
				<div className="panel panel-default">
					<CampaignList />
					<div className="panel-body actions">
						<div className="row">
							<div className="col-md-6">
								<button className="btn btn-new-folder" onClick={ Creators.createCampaign }>
									<span className="complex-icon top-right">
										<i className="fa fa-plus-circle small"></i>
										<i className="fa fa-folder-o"></i>
									</span>
									{ _('Nova mapa')}
								</button>
							</div>
						</div>

					</div>
				</div>
			</div>
		} else {
			return null;
		}
	}
}

const Latest = Container.create(LatestContainer);
export default Latest;




// WEBPACK FOOTER //
// ./src/modules/campaign/latest.js